<template>
  <div>




    <div v-if="!isAddOrEditModel">
      <a class="btn btn-primary" href="#" @click="changeMode_Add"><i class="fas fa-plus-circle"></i></a>
    </div>

    <div v-if="isAddOrEditModel">
      <a class="btn btn-primary" href="#" @click="saveData_caseLog()"><i class="fa fa-save"></i> </a>
      <a class="btn btn-danger" href="#" @click="changeMode_ViewOnly()"><i class="fa fa-times-circle"></i> </a>


      <table class="table table-hover" style="width:400px">
        <thead class="thead-light">
        <tr>
          <th>標籤1</th>
          <th>標籤2</th>
          <th>標籤3</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="text-left">
            <input type="text" class="form-control"  placeholder="" v-model="dataCurrentRecord.tag1">
          </td>
          <td class="text-left">
            <input type="text" class="form-control"  placeholder="" v-model="dataCurrentRecord.tag2">
          </td>
          <td class="text-left">
            <input type="text" class="form-control"  placeholder="" v-model="dataCurrentRecord.tag3">
          </td>
        </tr>

        </tbody>
      </table>
      <textarea class="form-control" id="txtMemo" name="txtMemo" rows="10"  v-model="dataCurrentRecord.content"></textarea>

    </div>


    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>標籤1</th>
        <th>標籤2</th>
        <th>標籤3</th>
        <th>說明</th>
        <th>日期</th>
        <th>是否完成</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in datas" :key="index">
        <td class="text-center" width="250px">
          <a class="btn btn-primary" @click="changeMode_Edit(item.id)"><i class="fa fa-pen"></i> </a>
          <a class="btn btn-danger" @click="DataItem_Remove(item.id)"><i class="far fa-trash-alt">  </i></a>
<!--          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i>  </a>-->
<!--          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i>  </a>-->
        </td>
        <td>
          {{item.tag1}}
        </td>
        <td>
          {{item.tag2}}
        </td>
        <td>
          {{item.tag3}}
        </td>
        <td >
          {{item.content}}
        </td>
        <td >
          {{item.created_at|fmtDate}}
        </td>

        <td >
          <div v-if="item.isFinish">
            <a role="button" class="btn btn-secondary" href="#" @click="changeStatus(item.id,false)">是</a>
          </div>
          <div v-else>

            <a role="button" class="btn btn-danger" href="#" @click="changeStatus(item.id,true)">否</a>
          </div>

        </td>
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
/**

 **/
import arrayUtil from "../../../util/arrayUtil";
import util from "../../../util/util";
import apiTzsci from "@/views/tzsci/js/apiTzsci";


export default {
  //name: "showData",
  props: ["userId"],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:[],
      isAddOrEditModel:false,
      dataCurrentRecord:{},
    };
  },
  methods: {
    async loadData() {
      let datas=await apiTzsci.api_Admin_GetCaseLog(this.userId);

      this.datas=datas;
    },
    async changeMode_Add(){
      this.isAddOrEditModel=true;
      this.dataCurrentRecord={id:0,tag1:"",tag2:"",tag3:"",content:"",};
    },
    async changeMode_Edit(id){
      this.isAddOrEditModel=true;
      this.dataCurrentRecord=this.datas.find(s => s.id===id);
    },
    async changeMode_ViewOnly(){
      this.isAddOrEditModel=false;
      this.dataCurrentRecord={id:0,tag1:"",tag2:"",tag3:"",content:"",};
    },
    async saveData_caseLog(){
      await apiTzsci.api_Admin_UpdateCaseLog(this.dataCurrentRecord.id,this.userId, this.dataCurrentRecord.tag1,this.dataCurrentRecord.tag2,this.dataCurrentRecord.tag3,this.dataCurrentRecord.content,"");
      this.isAddOrEditModel=false;

      await this.loadData();
      await util.ShowMessage('儲存成功')
    },

    submit(){
      for (let i = 0; i < this.datas.Details.length; i++) {
        let item = this.datas.Details[i];

        if (item.Year===""){
          util.showErrorMessage("第"+i+1+" 行，「年」為必填欄位")
          return;
        }
        if (item.Month===""){
          util.showErrorMessage("第"+i+1+" 行，「月」為必填欄位")
          return;
        }
        if (item.Type===""){
          util.showErrorMessage("第"+i+1+" 行，「幣別」為必填欄位")
          return;
        }
        if (item.Rate===""){
          util.showErrorMessage("第"+i+1+" 行，「匯率」為必填欄位")
          return;
        }
      }

      // apiGPK.api_Save_datas(this.datas.SystemId,"",this.datas).then((data)=>{
      //   util.ShowMessage('儲存成功')
      // })
    },

    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.Id,this.datas,"Id","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.Id,this.datas,"Id","OrderKey")
    },
    DataItem_AddLast(){
      let newItem={
        Id:util.uuid(),
        Year:0,
        Moneth:0,
        Type:"",
        Rate:0,
        OrderKey:0,
      }

      arrayUtil.orderAppendLast(newItem,this.datas,"OrderKey")
    },
    DataItem_Insert(currentItem){
      let newItem={
        Id:util.uuid(),
        Year:0,
        Moneth:0,
        Type:"",
        Rate:0,
        OrderKey:0,
      }

      arrayUtil.orderInsert(newItem,currentItem,this.datas,"Id","OrderKey")
    },

    async DataItem_Remove(id){
      if (confirm('確定刪除?')) {
        // arrayUtil.removeByPredicate(this.datas,s => s.Id===item.Id);
        await apiTzsci.api_Admin_DelCaseLog(id);
        await this.loadData();
        await util.ShowMessage('刪除成功')
      }
    },
    async changeStatus(id,isFinish){
      apiTzsci.api_Admin_UpdateCaseLog_IsFinish(id,isFinish).then((data)=>{
        if (data.data.status==="success") {
          this.loadData();
        } else {
          alert(data.data.msg);
        }
      })
    },

  },
  mounted() {
    // this.loadData()
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
